module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/5@2x_83cea7226e8099aa318cc879885fb5e2.png";